// Theme for Credit Union Landing Page
// Inspired by BECU, Patelco, Provident: clean, trustworthy, community-first

import { createTheme } from "@mui/material/styles";

const creditUnionTheme = createTheme({
  palette: {
    primary: { main: "#2563A6" }, // deep blue
    secondary: { main: "#4CAF50" }, // green
    background: {
      default: "#F5F7FA", // soft neutral background
      paper: "#FFFFFF",
    },
    text: {
      primary: "#222E3A", // dark blue/gray for text
      secondary: "#4CAF50",
    },
  },
  typography: {
    fontFamily: "Inter, Arial, sans-serif",
    fontWeightBold: 700,
    fontWeightRegular: 400,
    h1: { fontSize: "2.2rem" },
    h2: { fontSize: "1.4rem" },
    body1: { fontSize: "1rem" },
  },
  shape: {
    borderRadius: 4,
  },
  customPalette: {
    accent: "#F5F7FA",
    tileBg: "#FFFFFF",
    tileBorder: "#E0E6ED",
    cta: "#2563A6",
    ctaText: "#FFFFFF",
    faqBg: "#F5F7FA",
    heroBg: "#E8F1F8",
  },
  shadows: ["none", "0 2px 8px rgba(34,46,58,0.06)", ...Array(23).fill("none")],
});

export default creditUnionTheme;
